import SQLStorage from '../../SQLStorage';
import Utilities from '../../Utilities';
import Storage from '../../Storage';

const URL = (state = {}, action) => {

    switch(action.type) {

        case "UPDATE_URL":
            return action.data;

        default:
            return state

    }

}

export default URL;
